/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable class-methods-use-this */
import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics';
import { MapTriggerFunction } from '../types';
import { mapMerge } from './mapMerge';
import { mapCommon } from './mapCommon';
import { mapScreen } from './mapScreen';
import { mapAsset } from './mapAsset';
import { mapPlayer } from './mapPlayer';
import {
    mapAppCloseCore,
    mapPlayback10Core,
    mapPlayback50Core,
    mapPlayback90Core,
    mapPlaybackPauseCore,
    mapPlaybackUnpauseCore,
    mapPlaybackStartCore,
    mapPlayerCloseCore,
    mapSceneViewCore,
    mapSearchCore,
    mapFavorite,
    mapSelectContent,
} from './mapEventCore';

export const TEALIUM_MAPPERS: Partial<Record<ANALYTICS_TRIGGERS, MapTriggerFunction>> = {
    [ANALYTICS_TRIGGERS.SCENE_VIEW]: mapMerge(mapCommon, mapScreen, mapSceneViewCore),
    [ANALYTICS_TRIGGERS.SEARCH]: mapMerge(mapCommon, mapScreen, mapSearchCore),
    [ANALYTICS_TRIGGERS.FAVORITE_ADD]: mapMerge(mapCommon, mapScreen, mapAsset, mapFavorite),
    [ANALYTICS_TRIGGERS.FAVORITE_REMOVE]: mapMerge(mapCommon, mapScreen, mapAsset, mapFavorite),
    [ANALYTICS_TRIGGERS.SELECT_CONTENT]: mapMerge(mapCommon, mapScreen, mapAsset, mapSelectContent),
    [ANALYTICS_TRIGGERS.PLAYBACK_10]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlayback10Core
    ),
    [ANALYTICS_TRIGGERS.PLAYBACK_50]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlayback50Core
    ),
    [ANALYTICS_TRIGGERS.PLAYBACK_90]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlayback90Core
    ),
    [ANALYTICS_TRIGGERS.PLAYBACK_PAUSE]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlaybackPauseCore
    ),
    [ANALYTICS_TRIGGERS.PLAYBACK_UNPAUSE]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlaybackUnpauseCore
    ),
    [ANALYTICS_TRIGGERS.PLAYBACK_START]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlaybackStartCore
    ),
    [ANALYTICS_TRIGGERS.APP_CLOSE]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapAppCloseCore
    ),
    [ANALYTICS_TRIGGERS.PLAYER_CLOSE]: mapMerge(
        mapCommon,
        mapScreen,
        mapAsset,
        mapPlayer,
        mapPlayerCloseCore
    ),
};

export const TEALIUM_TRIGGERS: ANALYTICS_TRIGGERS[] = Object.keys(
    TEALIUM_MAPPERS
) as ANALYTICS_TRIGGERS[];
